// extracted by mini-css-extract-plugin
module.exports = {"head":"ThanksAppMain_head__3LGrM","des":"ThanksAppMain_des__3ZBvY","btnCont":"ThanksAppMain_btnCont__3X3qb","btn1":"ThanksAppMain_btn1__3FTJp","btn2":"ThanksAppMain_btn2__3oyh5"};